<template>
  <div>
    <ListView
      ref="listView"
      :isFluid="true"
      title="佑安汽車服務公司"
      @reload="reload"
      @create="actionCreate"
      :search.sync="search"
      :data="data"
      :page.sync="page"
      :header="header"
      :enableCreate="true"
      :search-box-placeholder="placeholder"
      :itemClass="getRowClass"
      :dense="true"
    >
      <!-- Custom Search Box -->
      <template v-slot:searchBox>
        <span></span>
      </template>

      <!-- Filter Section -->
      <template v-slot:filter>
        <v-row dense class="filter-row">
          <v-col cols="auto">
            <v-select
              v-model="pendingSearchField"
              :items="searchFieldOptions"
              dense
              outlined
              hide-details
              label="搜尋欄位"
            />
          </v-col>
          <v-col cols="auto">
            <v-text-field
              v-model="pendingSearchVal"
              dense
              outlined
              hide-details
              :placeholder="searchFieldLabel"
              prepend-inner-icon="mdi-magnify"
              clearable
              @keyup.enter="applyFilters"
            />
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="payDateStartMenu"
              v-model="payDateStartMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.payDateStart"
                  label="收件日期 開始"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.payDateStart"
                @input="payDateStartMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="payDateEndMenu"
              v-model="payDateEndMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.payDateEnd"
                  label="收件日期 截止"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.payDateEnd"
                @input="payDateEndMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="inputDateStartMenu"
              v-model="inputDateStartMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.inputDateStart"
                  label="辦理日期 開始"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.inputDateStart"
                @input="inputDateStartMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="inputDateEndMenu"
              v-model="inputDateEndMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.inputDateEnd"
                  label="辦理日期 截止"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.inputDateEnd"
                @input="inputDateEndMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="finishDateStartMenu"
              v-model="finishDateStartMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.finishDateStart"
                  label="到期日 開始"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.finishDateStart"
                @input="finishDateStartMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="finishDateEndMenu"
              v-model="finishDateEndMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.finishDateEnd"
                  label="到期日 截止"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.finishDateEnd"
                @input="finishDateEndMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.serviceType"
              :items="serviceTypeOptions"
              dense
              outlined
              hide-details
              label="服務選擇"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.status"
              :items="statusOptions"
              dense
              outlined
              hide-details
              label="狀態選擇"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingSortBy"
              :items="sortOptions"
              dense
              outlined
              hide-details
              label="排序顯示"
            />
          </v-col>
          <v-col cols="auto">
            <v-autocomplete
              v-model="pendingFilters.createdBy"
              :items="creatorOptions"
              item-text="text"
              item-value="value"
              dense
              outlined
              hide-details
              label="創建人"
              clearable
            />
          </v-col>
          <v-col cols="auto" class="d-flex align-center gap-2">
            <v-btn color="primary" @click="applyFilters" :loading="isLoading" :disabled="isLoading">
              <v-icon left>mdi-magnify</v-icon>
              搜尋
            </v-btn>
            <v-btn color="default" @click="resetFilters" :disabled="isLoading">
              <v-icon left>mdi-refresh</v-icon>
              清除選項
            </v-btn>
            <v-btn color="default" @click="handlePrint" :disabled="isLoading">
              <v-icon left>mdi-printer</v-icon>
              列印
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item._yomtAlert="{ item }">
        <span v-if="isPrinting && isYomtAlertActive(item)" :class="yomtAlertMarkClass(item)"
          >!</span
        >
        <v-tooltip v-else-if="!isPrinting && isYomtAlertActive(item)" bottom open-delay="200">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" :class="yomtAlertMarkClass(item)" @click.stop>!</span>
          </template>
          <span>{{ yomtAlertTooltip(item) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.payDate="{ item }">
        {{ item.payDate | moment('YYYY-MM-DD') }}
      </template>
      <template v-slot:item.finishDate="{ item }">
        <span v-if="item.finishDate">{{ item.finishDate | moment('YYYY-MM-DD') }}</span>
        <span v-else></span>
      </template>
      <template v-slot:item.inputDate="{ item }">
        <span v-if="item.inputDate">{{ item.inputDate | moment('YYYY-MM-DD') }}</span>
        <span v-else></span>
      </template>
      <template v-slot:item.customerTel="{ item }">
        <a
          v-if="item.customerTel"
          :href="generateCustomerWhatsAppUrl(item)"
          target="_blank"
          class="clickable-link"
          @click.stop
        >
          {{ item.customerTel }}
        </a>
        <span v-else></span>
      </template>
      <template v-slot:item.agentTel="{ item }">
        <a
          v-if="item.agentTel"
          :href="generateAgentWhatsAppUrl(item)"
          target="_blank"
          class="clickable-link"
          @click.stop
        >
          {{ item.agentTel }}
        </a>
        <span v-else></span>
      </template>
      <template v-slot:item.service1="{ item }">
        {{ item.services && item.services[0] ? item.services[0].name : '' }}
      </template>
      <template v-slot:item.service2="{ item }">
        {{ item.services && item.services[1] ? item.services[1].name : '' }}
      </template>
      <template v-slot:item.service3="{ item }">
        {{ item.services && item.services[2] ? item.services[2].name : '' }}
      </template>
      <template v-slot:item.totalFee="{ item }">
        ${{ calculateTotalFee(item) | toThousandFilter }}
      </template>
      <template v-slot:item.attachments="{ item }">
        <span v-if="item.attachments && item.attachments.length > 0">附件</span>
        <span v-else></span>
      </template>
      <template v-slot:item.createdByName="{ item }">
        {{ item.createdBy && item.createdBy.name ? item.createdBy.name : '' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="primary" @click.stop="actionDetails(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small color="success" @click.stop="actionDuplicate(item)">
          <v-icon small>mdi-plus-circle-outline</v-icon>
        </v-btn>
        <v-btn icon small color="info" @click.stop="actionPrint(item)">
          <v-icon small>mdi-printer</v-icon>
        </v-btn>
      </template>
      <template v-slot:body.append>
        <tr class="font-weight-bold grey lighten-3 yomt-total-row">
          <template v-if="isPrinting">
            <td :colspan="12" style="text-align: right">總計:</td>
            <td :colspan="3">${{ totalFeesSum | toThousandFilter }}</td>
          </template>
          <template v-else>
            <td colspan="11"></td>
            <td class="yomt-total-label-cell">總計:</td>
            <td class="yomt-total-fee-cell">${{ totalFeesSum | toThousandFilter }}</td>
            <td></td>
            <td></td>
            <td></td>
          </template>
        </tr>
      </template>
    </ListView>

    <YOMTDetailsDialog
      v-model="editDialog"
      :id="editId"
      :initial-data="initialData"
      @saved="handleSaved"
      @deleted="handleDeleted"
    />
  </div>
</template>

<script>
import { RESTFUL } from '@/data/constants';
import listViewPageMixin from '@/services/listViewPageMixin';
import { mapGetters } from 'vuex';
import YOMTDetailsDialog from '@/components/YOMT/YOMTDetailsDialog';
import dayjs from 'dayjs';
import api from '@/api';
import { crudRead } from '@/api/crud';
import { printYOMT } from '@/services/utils';

const YOMT_LICENSE_RENEWAL_SERVICE_NAMES = ['續領車輛牌照一年', '續領車輛牌照一季'];
const YOMT_STANDARD_SERVICE_FILTER_NAMES = ['保險', '續領車輛牌照一年', '續領車輛牌照一季'];

/** Alert when 保險 is present without license renewal (一年 / 一季). */
function isYomtAlertEligibleByServiceNames(serviceNames) {
  if (!serviceNames?.length) return false;
  const names = serviceNames.filter(Boolean);
  if (!names.includes('保險')) return false;
  return !names.some(name => YOMT_LICENSE_RENEWAL_SERVICE_NAMES.includes(name));
}

/** Mongo filter block for !保險辦理 (matches isYomtAlertActive scenarios A/B/C). */
function buildYomtAlertMongoFilterBlock() {
  const endWindow = dayjs().add(2, 'day').endOf('day').toDate();
  const payDateCutoff = dayjs().subtract(5, 'day').startOf('day').toDate();
  const noInputDate = {
    $or: [{ inputDate: { $exists: false } }, { inputDate: null }],
  };
  return {
    $and: [
      noInputDate,
      {
        services: { $elemMatch: { name: '保險' } },
      },
      {
        $nor: YOMT_LICENSE_RENEWAL_SERVICE_NAMES.map(name => ({
          services: { $elemMatch: { name } },
        })),
      },
      {
        $or: [
          {
            finishDate: {
              $exists: true,
              $ne: null,
              $lte: endWindow,
            },
          },
          {
            $and: [
              { $or: [{ finishDate: { $exists: false } }, { finishDate: null }] },
              { payDate: { $lte: payDateCutoff } },
            ],
          },
        ],
      },
    ],
  };
}

export default {
  name: 'YOMT',
  props: {},
  components: {
    YOMTDetailsDialog,
  },
  data() {
    return {
      limit: 100,
      populate: [{ path: 'createdBy', select: ['name'] }],
      creatorOptions: [],
      editDialog: false,
      editId: 'new',
      initialData: null,
      // Filter data
      searchField: 'customer',
      pendingSearchField: 'customer',
      pendingSearchVal: '',
      searchFieldOptions: [
        { text: '客戶名稱', value: 'customer' },
        { text: '車牌號碼', value: 'vehno' },
        { text: '代理人', value: 'agent' },
        { text: '客戶電話', value: 'customerTel' },
        { text: '代理人電話', value: 'agentTel' },
      ],
      filters: {
        payDateStart: null,
        payDateEnd: null,
        inputDateStart: null,
        inputDateEnd: null,
        finishDateStart: null,
        finishDateEnd: null,
        serviceType: null,
        status: null,
        createdBy: null,
      },
      pendingFilters: {
        payDateStart: null,
        payDateEnd: null,
        inputDateStart: null,
        inputDateEnd: null,
        finishDateStart: null,
        finishDateEnd: null,
        serviceType: null,
        status: null,
        createdBy: null,
      },
      payDateStartMenu: false,
      payDateEndMenu: false,
      inputDateStartMenu: false,
      inputDateEndMenu: false,
      finishDateStartMenu: false,
      finishDateEndMenu: false,
      sort: { updatedAt: -1 },
      sortBy: 'updatedAt',
      pendingSortBy: 'updatedAt',
      sortOptions: [
        { text: '按更新日期先後排序（默認） ↓', value: 'updatedAt' },
        { text: '按辦理日期先後排序 ↓', value: 'inputDate' },
        { text: '按收件日期先後排序 ↓', value: 'payDate' },
        { text: '到期日先後排序 ↓', value: 'finishDate' },
        { text: '按數據ID先後排序 ↓', value: '_id' },
      ],
      serviceTypeOptions: [
        { text: '保險+其它', value: '1' },
        { text: '續領車輛牌照一年/一季', value: '2' },
        { text: '保險', value: '3' },
        { text: '其他', value: '4' },
      ],
      statusOptions: [
        { text: '尚未辦理', value: '1' },
        { text: '尚欠文件', value: '2' },
        { text: '尚未付款', value: '3' },
        { text: '緊急辦理', value: '5' },
        { text: '!保險辦理', value: '6' },
      ],

      //print
      isPrinting: false,
    };
  },
  mixins: [listViewPageMixin],
  async mounted() {
    // Set initial sort
    this.updateSort();
    // Load admin profiles for createdBy filter
    try {
      const res = await api.get('v1/profiles', {
        params: { filter: { role: 'admin' }, limit: 200, paginate: true },
      });
      this.creatorOptions = (res.data.docs || []).map(p => ({
        text: p.name || p._id,
        value: p._id,
      }));
    } catch (e) {
      console.error('Failed to load creator options', e);
    }
  },
  computed: {
    ...mapGetters('auth', ['role', 'isMaster']),
    restfulURL() {
      return RESTFUL.yomt.list;
    },
    placeholder() {
      return '搜尋車牌號碼 / 客戶 / 電話 / 代理人';
    },
    searchFieldLabel() {
      const field = this.searchFieldOptions.find(f => f.value === this.pendingSearchField);
      return field ? `請輸入${field.text}` : '請輸入搜尋內容';
    },
    searchPaths() {
      // Return the applied search field as search path
      return this.searchField ? [this.searchField] : undefined;
    },
    header() {
      return [
        {
          text: '',
          value: '_yomtAlert',
          sortable: false,
          align: 'center',
          width: '40px',
        },
        { text: '收件日期', value: 'payDate' },
        { text: '車牌號碼', value: 'vehno' },
        { text: '到期日', value: 'finishDate' },
        { text: '辦理日期', value: 'inputDate' },
        { text: '客戶名稱', value: 'customer', cellClass: 'keep-all' },
        { text: '客戶電話', value: 'customerTel' },
        { text: '代理人', value: 'agent' },
        { text: '代理人電話', value: 'agentTel' },
        { text: '代辦服務1', value: 'service1' },
        { text: '代辦服務2', value: 'service2' },
        { text: '代辦服務3', value: 'service3' },
        { text: '手續費總計', value: 'totalFee' },
        { text: '附件', value: 'attachments' },
        { text: '創建人', value: 'createdByName' },
        ...(this.isPrinting
          ? []
          : [
              {
                text: '操作',
                value: 'actions',
                sortable: false,
              },
            ]),
      ];
    },
    filter() {
      const filter = {};

      // Pay date range filter
      if (this.filters.payDateStart || this.filters.payDateEnd) {
        filter.payDate = {};
        if (this.filters.payDateStart) {
          filter.payDate.$gte = dayjs(this.filters.payDateStart).startOf('day').toDate();
        }
        if (this.filters.payDateEnd) {
          filter.payDate.$lte = dayjs(this.filters.payDateEnd).endOf('day').toDate();
        }
      }

      // Input date range filter
      if (this.filters.inputDateStart || this.filters.inputDateEnd) {
        filter.inputDate = {};
        if (this.filters.inputDateStart) {
          filter.inputDate.$gte = dayjs(this.filters.inputDateStart).startOf('day').toDate();
        }
        if (this.filters.inputDateEnd) {
          filter.inputDate.$lte = dayjs(this.filters.inputDateEnd).endOf('day').toDate();
        }
      }

      // Finish date range filter
      if (this.filters.finishDateStart || this.filters.finishDateEnd) {
        filter.finishDate = {};
        if (this.filters.finishDateStart) {
          filter.finishDate.$gte = dayjs(this.filters.finishDateStart).startOf('day').toDate();
        }
        if (this.filters.finishDateEnd) {
          filter.finishDate.$lte = dayjs(this.filters.finishDateEnd).endOf('day').toDate();
        }
      }

      // Service type filter
      if (this.filters.serviceType) {
        // Note: This is a simplified filter, might need backend logic for complex service filtering
        // filter._serviceType = this.filters.serviceType;
        switch (this.filters.serviceType) {
          case '1':
            filter.services = { $elemMatch: { name: '保險' } };
            break;
          case '2':
            filter.services = {
              $elemMatch: {
                name: { $in: YOMT_LICENSE_RENEWAL_SERVICE_NAMES },
              },
            };
            break;
          case '3':
            // 保險: only has '保險' service (and no other services)
            filter.$and = [
              { services: { $elemMatch: { name: '保險' } } },
              { 'services.1': { $exists: false } },
            ];
            break;
          case '4':
            // 其他: exclude 保險 and license renewal services
            filter.$nor = YOMT_STANDARD_SERVICE_FILTER_NAMES.map(name => ({
              services: { $elemMatch: { name } },
            }));
            break;
        }
      }

      // Status filter
      if (this.filters.status) {
        const status = this.filters.status;
        if (status === '1') {
          // 尚未辦理 - inputDate does not exist or is null
          filter.$or = [{ inputDate: { $exists: false } }, { inputDate: null }];
        } else if (status === '2') {
          // 尚欠文件 - othersList.0 exists
          filter['othersList.0'] = { $exists: true };
        } else if (status === '3') {
          // 尚未付款 - payment.paid is not equal to true
          filter['payment.paid'] = { $ne: true };
        } else if (status === '5') {
          // 緊急辦理 - isJj is true OR overdue OR expire soon (all require no inputDate);
          // exclude !保險辦理 rows (handled by status '6')
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const dayAfterTomorrow = new Date(today);
          dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
          dayAfterTomorrow.setHours(23, 59, 59, 999); // End of day after tomorrow

          const alertBlock = buildYomtAlertMongoFilterBlock();
          filter.$and = [
            // Must have no inputDate (not completed)
            { $or: [{ inputDate: { $exists: false } }, { inputDate: null }] },
            // AND one of these conditions
            {
              $or: [
                { isJj: true }, // 緊急處理 ticked
                { finishDate: { $lte: dayAfterTomorrow } }, // overdue or expiring within 2 days
              ],
            },
            { $nor: [alertBlock] },
          ];
        } else if (status === '6') {
          // !保險辦理 — same rules as isYomtAlertActive (scenarios A/B/C, no inputDate)
          const alertBlock = buildYomtAlertMongoFilterBlock();
          if (Object.keys(filter).length === 0) {
            Object.assign(filter, alertBlock);
          } else {
            const rest = { ...filter };
            Object.keys(filter).forEach(k => delete filter[k]);
            filter.$and = [rest, alertBlock];
          }
        }
      }

      // createdBy filter
      if (this.filters.createdBy) {
        filter.createdBy = this.filters.createdBy;
      }

      return Object.keys(filter).length > 0 ? filter : null;
    },
    totalFeesSum() {
      if (!this.data || !this.data.docs || this.data.docs.length === 0) {
        return 0;
      }
      return this.data.docs.reduce((sum, item) => {
        return sum + this.calculateTotalFee(item);
      }, 0);
    },
  },
  methods: {
    async handlePrint() {
      // Call the ListView's print method
      if (this.$refs.listView) {
        this.isPrinting = true;
        await this.$nextTick();
        this.$refs.listView.handlePrint();

        this.isPrinting = false;
      }
    },
    updateSort() {
      // Update the sort data property based on sortBy selection
      if (this.sortBy === 'inputDate') {
        this.sort = { inputDate: -1 };
      } else if (this.sortBy === 'payDate') {
        this.sort = { payDate: -1 };
      } else if (this.sortBy === 'finishDate') {
        this.sort = { finishDate: -1 };
      } else if (this.sortBy === '_id') {
        this.sort = { _id: -1 };
      } else {
        // Default: updatedAt
        this.sort = { updatedAt: -1 };
      }
    },
    applyFilters() {
      // Apply pending values to actual filter values
      this.searchField = this.pendingSearchField;
      this.search = this.pendingSearchVal || '';
      this.filters = { ...this.pendingFilters };
      this.sortBy = this.pendingSortBy;
      this.updateSort();

      this.debouncedSearch();
    },
    resetFilters() {
      // Reset only pending filters (not applied filters)
      this.pendingSearchField = 'customer';
      this.pendingSearchVal = '';
      this.pendingFilters = {
        payDateStart: null,
        payDateEnd: null,
        inputDateStart: null,
        inputDateEnd: null,
        finishDateStart: null,
        finishDateEnd: null,
        serviceType: null,
        status: null,
        createdBy: null,
      };
      this.pendingSortBy = 'updatedAt';
    },
    /** Scenario A: with expiry — finishDate strictly before today */
    isYomtAlertScenarioA(finishDate) {
      if (!finishDate) return false;
      const today = dayjs().startOf('day');
      return dayjs(finishDate).startOf('day').isBefore(today);
    },
    /** Scenario B: with expiry — from 2 calendar days before expiry through expiry day */
    isYomtAlertScenarioB(finishDate) {
      if (!finishDate) return false;
      const today = dayjs().startOf('day');
      const finish = dayjs(finishDate).startOf('day');
      const daysUntil = finish.diff(today, 'day');
      return daysUntil >= 0 && daysUntil <= 2;
    },
    /** Deep-green ! mark: expiry 1–2 calendar days away (tomorrow through day after). */
    isYomtAlertGreenMarkByFinishDate(finishDate) {
      if (!finishDate) return false;
      const daysUntil = dayjs(finishDate).startOf('day').diff(dayjs().startOf('day'), 'day');
      return daysUntil >= 1 && daysUntil <= 2;
    },
    /** Scenario C: without expiry — 5+ calendar days after payDate */
    isYomtAlertScenarioC(finishDate, payDate) {
      if (finishDate) return false;
      if (!payDate) return false;
      const alertFrom = dayjs(payDate).startOf('day').add(5, 'day');
      return !dayjs().startOf('day').isBefore(alertFrom);
    },
    /** Alerts apply when services include 保險 but not license renewal (一年 / 一季). */
    isYomtAlertEligibleServices(item) {
      const services = item?.services;
      if (!services?.length) return false;
      return isYomtAlertEligibleByServiceNames(services.map(s => s?.name));
    },
    isYomtAlertActive(item) {
      if (!this.isYomtAlertEligibleServices(item)) return false;
      if (item?.inputDate) return false;
      return (
        this.isYomtAlertScenarioA(item?.finishDate) ||
        this.isYomtAlertScenarioB(item?.finishDate) ||
        this.isYomtAlertScenarioC(item?.finishDate, item?.payDate)
      );
    },
    yomtAlertTooltip(item) {
      if (!this.isYomtAlertEligibleServices(item)) return '';
      if (item?.inputDate) return '';
      if (this.isYomtAlertScenarioA(item?.finishDate)) return '到期日已過（早於今日）';
      if (this.isYomtAlertScenarioB(item?.finishDate)) return '到期日在2個曆日內（含今日）';
      if (this.isYomtAlertScenarioC(item?.finishDate, item?.payDate))
        return '缺少到期日，且收件已滿5個曆日';
      return '';
    },
    yomtAlertMarkClass() {
      return 'yomt-alert-mark';
    },
    calculateTotalFee(item) {
      if (!item.services || item.services.length === 0) {
        return 0;
      }
      const total = item.services.reduce((sum, service) => {
        return sum + (service.price2 || 0);
      }, 0);
      return total;
    },
    actionCreate() {
      this.editId = 'new';
      this.initialData = null;
      this.editDialog = true;
    },
    actionDetails(item) {
      this.editId = item._id;
      this.initialData = null;
      this.editDialog = true;
    },
    actionDuplicate(item) {
      // Prepare data for duplication with selected fields only
      this.editId = 'new';
      this.initialData = {
        vehno: item.vehno,
        customer: item.customer,
        customerTel: item.customerTel,
        agent: item.agent,
        agentTel: item.agentTel,
        isTel: item.isTel,
        isJj: item.isJj,
      };
      this.editDialog = true;
    },
    async actionPrint(item) {
      try {
        // Fetch full YOMT data with all details
        const yomtData = await crudRead(api, RESTFUL.yomt.read, item._id, {
          populates: [{ path: 'createdBy', select: ['name'] }],
        });

        // Call the print function
        printYOMT(yomtData);
      } catch (error) {
        console.error('Failed to load YOMT data for printing:', error);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: '載入列印資料失敗',
          type: 'error',
          color: 'error',
        });
      }
    },
    handleSaved() {
      this.initialData = null;
      this.reload();
    },
    handleDeleted() {
      this.initialData = null;
      this.reload();
    },
    generateCustomerWhatsAppUrl(item) {
      if (!item.customerTel) return '#';

      // Format phone number - remove any spaces, dashes, or special characters
      let phoneNumber = item.customerTel.replace(/[\s\-()]/g, '');

      // Prepend 852 if not already present
      if (!phoneNumber.startsWith('852')) {
        phoneNumber = '852' + phoneNumber;
      }

      // Get vehicle number
      const vehicleNumber = item.vehno || '';

      // Construct the message with dynamic data
      const message = `您好! ［ 佑安汽車服務公司 ］現通知閣下,車牌號碼${vehicleNumber}文件已辦妥,煩請到取,謝謝!`;

      // URL encode the message
      const encodedMessage = encodeURIComponent(message);

      // Return the full WhatsApp URL
      return `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
    },
    generateAgentWhatsAppUrl(item) {
      if (!item.agentTel) return '#';

      // Format phone number - remove any spaces, dashes, or special characters
      let phoneNumber = item.agentTel.replace(/[\s\-()]/g, '');

      // Prepend 852 if not already present
      if (!phoneNumber.startsWith('852')) {
        phoneNumber = '852' + phoneNumber;
      }

      // Get vehicle number
      const vehicleNumber = item.vehno || '';

      // Construct the message with dynamic data
      const message = `您好! ［ 佑安汽車服務公司 ］現通知閣下,車牌號碼${vehicleNumber}文件已辦妥,煩請到取,謝謝!`;

      // URL encode the message
      const encodedMessage = encodeURIComponent(message);

      // Return the full WhatsApp URL
      return `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
    },
    getRowClass(item) {
      const today = dayjs().startOf('day');
      // 到期日
      const finishDate = item.finishDate ? dayjs(item.finishDate).startOf('day') : null;
      const tomorrow = today.add(1, 'day');
      const dayAfterTomorrow = today.add(2, 'days');

      // If inputDate（辦理日期) exists (completion date inputted), return normal (black)
      if (item.inputDate) {
        return '';
      }

      // Insurance alert: deep-green whole row when expiry 1–2 days away
      if (
        this.isYomtAlertActive(item) &&
        this.isYomtAlertGreenMarkByFinishDate(item?.finishDate)
      ) {
        return 'deep-green-row';
      }

      // Other alerted rows (!): normal row color; alert icon carries the warning
      if (this.isYomtAlertActive(item)) {
        return '';
      }

      // No completion date, not alerted — apply red / green rules

      // Check if expired or expiring today (RED)
      if (finishDate && finishDate.valueOf() <= today.valueOf()) {
        return 'red-row';
      }

      // Check if 緊急處理 is ticked (RED)
      if (item.isJj) {
        return 'red-row';
      }

      // Check if expiring tomorrow or day after tomorrow (DEEP GREEN)
      if (
        finishDate &&
        (finishDate.valueOf() === tomorrow.valueOf() ||
          finishDate.valueOf() === dayAfterTomorrow.valueOf())
      ) {
        return 'deep-green-row';
      }

      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@mixin colored-row($color) {
  color: $color !important;
  font-weight: bold !important;
  a {
    color: $color !important;
  }
}

/* Red row: overdue/today expiry or 緊急處理 (with no completion date) */
::v-deep .red-row {
  @include colored-row(var(--yomt-row-red));
}

/* Deep green row: expiring tomorrow or day after (with no completion date) */
::v-deep .deep-green-row {
  @include colored-row(var(--yomt-row-green));
}

.yomt-alert-mark {
  color: var(--yomt-row-red) !important;
  font-weight: 800;
  font-size: 1.125rem;
  line-height: 1;
  cursor: help;
  display: inline-block;
  min-width: 1rem;
  text-align: center;
}

::v-deep .yomt-total-row .yomt-total-label-cell {
  text-align: right;
}

::v-deep .yomt-total-row .yomt-total-fee-cell {
  text-align: left;
}
</style>

<style lang="scss">
/* Ensure row colors appear in print preview as they do on screen */
@media print {
  .red-row {
    color: var(--yomt-row-red) !important;
    font-weight: bold !important;
  }
  .red-row a {
    color: var(--yomt-row-red) !important;
  }
  .deep-green-row {
    color: var(--yomt-row-green) !important;
    font-weight: bold !important;
  }
  .deep-green-row a {
    color: var(--yomt-row-green) !important;
  }
  .yomt-alert-mark {
    color: var(--yomt-row-red) !important;
    font-weight: 800 !important;
  }
}
</style>
